module.exports = __webpack_public_path__ + "img/b5-2.1209a7d.png";